module.exports = __webpack_public_path__ + "static/media/Top_Logos_qz.6c34ef88.png";